export const USER_ROLE = "USER";
export const AI_ROLE = "ASSISTANT";

export const CHAT = "chat";
export const ROLEPLAY = "roleplay";
export const LEARNING_PLAN = "learning_plan";
export const VOCAB_EXPANSION = "vocab_expansion";
export const TOPIK_GENERATION = "topik_generation";
export const TOPIK_WRITING = "topik_writing";
